export function isDevelopment(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.endsWith('.local') ||
    host.startsWith('192.168.')
  );
}

export function getApiBaseUrl(): string {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}
